import Vue from 'vue'
import Vuex from 'vuex'

import auth from './auth'
import cart from './cart'
import products from './products'
import filters from './filters'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    auth,
    products,
    filters,
    cart
  }
})

export default store
